import React, { Component } from "react";
import Snackbar from "@material-ui/core/Snackbar";
import axios from "axios";
import Footer from "../../components/footer/Footer";
import Cookies from "universal-cookie";
import { CAMS_URL, FETCH_URL } from "../../constants/ServerLinks";
import Messages from "../../components/messages/Messages";

import "./RoleAssignment.scss";

class RoleAssignment extends Component {
  constructor(props) {
    super(props);
    this.fetchURL = FETCH_URL;
    this.camsURL = CAMS_URL;
    this.cookies = new Cookies();
    this.city_skey = this.cookies.get("city_skey");

    this.state = {
      student_role: "",
      student_name: "",
      student_email: "",
      game_code: "",
      navLinks: [
        // {
        //   name: "Frank Batten School",
        //   href: "https://batten.virginia.edu",
        //   icon: "iconBatten",
        //   text: "textBatten",
        //   target: "_blank",
        // },
        // {
        //   name: "CLSG",
        //   href: "https://www.clsgbatten.org",
        //   icon: "iconClsg",
        //   text: "textClsg",
        //   target: "_blank",
        // },
        {
          href: "https://dms.academy/",
          icon: "iconDMS",
          target: "_blank",
        },
      ],
    };
  }

  onChange = (e) => {
    e.preventDefault();
    const name = e.target.name;
    const value = e.target.value;

    console.log("name and value: " + name + " " + value);

    this.setState({
      [name]: value,
    });

    if (name === "student_role" && value === "City Manager") {
      console.log("Congrats you are a city manager!");
      this.setState({
        is_manager: true,
      });
    } else if (name === "student_role" && value !== "City Manager") {
      this.setState({
        is_manager: false,
      });
    }
  };

  fetchParticipants = (city_skey) => {
    axios.get(this.fetchURL + "/api/v1/participants/", {
      params: { city_skey: city_skey },
    });
  };

  onStudentJoin = (e) => {
    e.preventDefault();

    axios
      .post(this.fetchURL + "/api/v1/participants/", {
        student_name: this.state.student_name,
        student_email: this.state.student_email,
        game_code: this.state.game_code,
        is_manager: this.state.is_manager,
        student_role: this.state.student_role,
        student_team_name: "1",
      })
      .then((response) => {
        console.log(response.data);
        this.setState({ requestSent: false });

        if (response.data.success) {
          this.setState({
            snackOpen: true,
            snackMsg: `Authentication successful!`,
            snackType: "snack-success",
          });
          const data = response.data.data;
          this.cookies.set("city_skey", data.city_skey, {
            maxAge: 86400,
            path: "/",
          });
          this.cookies.set("city_name", data.city_name, {
            maxAge: 86400,
            path: "/",
          });
          this.cookies.set("p_id", data.id, { maxAge: 86400, path: "/" });
          this.cookies.set("s_name", this.state.student_name, {
            maxAge: 86400,
            path: "/",
          });
          this.cookies.set("s_email", this.state.student_email, {
            maxAge: 86400,
            path: "/",
          });
          this.cookies.set("game_code", this.state.game_code, {
            maxAge: 86400,
            path: "/",
          });
          this.cookies.set("student_is_manager", data.is_manager, {
            maxAge: 86400,
            path: "/",
          });
          this.cookies.set("student_role", data.student_role, {
            maxAge: 86400,
            path: "/",
          });
          this.cookies.set("student_team_name", data.student_team_name, {
            maxAge: 86400,
            path: "/",
          });
          this.fetchParticipants(data.city_skey);
          window.location.assign("/");
        } else {
          this.setState({
            snackOpen: true,
            snackMsg: response.data.message,
            snackType: "snack-error",
          });
        }
      })
      .catch((error) => {
        console.log(error.message);
        this.setState({
          snackOpen: true,
          snackMsg: "Something went wrong. Please try again later.",
          snackType: "snack-error",
        });
        this.setState({ requestSent: false });
      });
  };

  componentDidMount() {
    const student_name = window.location.href.split("/")[4].replace("%20", " ");
    const student_email = window.location.href.split("/")[5];
    const game_code = window.location.href.split("/")[6];
    const origin = window.location.href.split("/")[7];
    console.log(origin);
    if (origin) {
      this.cookies.set("origin", origin, { maxAge: 86400, path: "/" });
    } else {
      this.cookies.set("origin", "NOT_CLSG", { maxAge: 86400, path: "/" });
    }
    this.setState({
      student_name: student_name,
      student_email: student_email,
      game_code: game_code,
    });
    this.cookies.set("s_name", window.location.href.split("/")[4]);
    this.cookies.set("s_email", window.location.href.split("/")[5]);
    this.cookies.set("game_code", window.location.href.split("/")[6]);
  }

  render() {
    const student_role = [
      {
        value: "",
        role: "Select Your Role",
      },
      {
        value: "City Manager",
        role: "City Manager",
      },
      {
        value: "City Treasurer",
        role: "City Treasurer",
      },
      {
        value: "Transportation Commissioner",
        role: "Transportation Commissioner",
      },
      {
        value: "Health Commissioner",
        role: "Health Commissioner",
      },
      {
        value: "Young People",
        role: "Young People",
      },
      {
        value: "Old People",
        role: "Old People",
      },
      {
        value: "Developers' Assoc.",
        role: "Developers' Assoc.",
      },
      {
        value: "Chamber of Commerce",
        role: "Chamber of Commerce",
      },
      {
        value: "Social Services Commissioner",
        role: "Social Services Commissioner",
      },
      {
        value: "Rich Pops",
        role: "Rich Pops",
      },
      {
        value: "Poor Pops",
        role: "Poor Pops",
      },
      {
        value: "Jacobs Hill Prez",
        role: "Jacobs Hill Prez",
      },
      {
        value: "Howard Gardens Prez",
        role: "Howard Gardens Prez",
      },
      {
        value: "Moses Gulch Prez",
        role: "Moses Gulch Prez",
      },
      {
        value: "Corbusville Prez",
        role: "Corbusville Prez",
      },
      {
        value: "Downtown Prez",
        role: "Downtown Prez",
      },
    ];
    return (
      <div className={`roleSelectionPage`}>
        <div className="instructorNav flex flex-justify-between">
          <div className="sudoLogo" />
          <div className="metroLogo" />
          <div
            className="familyLogos flex flex-justify-between"
            style={{ flexDirection: "row", marginTop: "20px" }}
          >
            {this.state.navLinks.map((item, index) => (
              <a
                className="flex flex-items-center"
                key={index}
                href={item.href}
                target={item.target}
                style={{ flexDirection: "column" }}
              >
                <span className={item.icon} style={{ marginLeft: "30px" }} />
                <span
                  style={{
                    marginLeft: "30px",
                    fontFamily:
                      'proxima-nova, "Helvetica Neue", Helvetica, Arial, sans-serif',
                    fontSize: ".8vw",
                    fontWeight: 500,
                    fontStyle: "normal",
                    color: "#232d4b",
                  }}
                >
                  {item.name}
                </span>
              </a>
            ))}
          </div>
        </div>
        <div className="backgroundPic" />
        <div
          className={`flex flex-justify-center flex-items-center roleSelectionContainer`}
        >
          <div className={`roleSelectionPane`}>
            <h1>Welcome to Metropolitan, {this.state.student_name}.</h1>
            <h5>Please Select a Role</h5>
            <form onSubmit={(e) => this.onStudentJoin(e)}>
              <label
                ref={(a) => (this.labeltest = a)}
                className="formLabel"
                htmlFor="student_role"
              >
                Role
              </label>
              <select
                className="studentSelect"
                name="student_role"
                value={this.state.student_role}
                onChange={(e) => this.onChange(e)}
                id="student_role"
                required
              >
                {student_role.map((item, index) => (
                  <option key={index} value={item.value} name="student_role">
                    {item.role}
                  </option>
                ))}
              </select>
              <button
                type="submit"
                className="loginBtn"
                disabled={this.state.requestSent ? "disabled" : ""}
              >
                {this.state.requestSent ? "Joining . . ." : "Join"}
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default RoleAssignment;
